import { ViewState } from "@/interfaces/ViewState";

let state = {};
const getters = {};
const actions = {
  updateViewState(context: any, viewState: ViewState ) {
    context.commit('updateViewState', viewState);
  },
  clearViewState(context: any) {
    context.commit('clearViewState');
  }
};

const mutations = {
  updateViewState(state: any, viewState: ViewState) {
    state[viewState.name] = viewState.value;
  },
  clearViewState(state: any) {
    state = {};
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/store/modules/viewState.ts